import { SxProps, Theme } from '@mui/material/styles';

export const filtersContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
  paddingBottom: '24px',
};

export const mlAuto: SxProps<Theme> = {
  marginLeft: 'auto',
};

export const innerRowSx: SxProps<Theme> = {
  flexWrap: 'nowrap',
};

export const innerComparisonFormSx: SxProps<Theme> = {
  mt: 1,
};

export const filterItemBoxSx: SxProps<Theme> = {
  flex: '0 0 auto',
  display: 'inline-flex',
};

export const makeScrollGridSx = (theme: Theme, canScrollLeft: boolean, canScrollRight: boolean): SxProps<Theme> => {
  const startColor = canScrollLeft ? 'transparent' : 'black';
  const endColor = canScrollRight ? 'transparent' : 'black';
  return {
    overflowX: 'auto',
    width: '100%',
    maxWidth: `calc(100% - ${theme.spacing(2)})`,
    boxSizing: 'border-box',
    minWidth: 0,
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
    maskImage: `linear-gradient(to right, ${startColor}, black 20px, black calc(100% - 30px), ${endColor})`,
  };
};

export const editFiltersPopoverContainerSx: SxProps<Theme> = {
  p: 3,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  maxWidth: '443px',
};

export const editFiltersHeaderSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const editFiltersCloseButtonSx: SxProps<Theme> = (theme: Theme) => ({
  '&:focus-visible': {
    boxShadow: 'none',
    outline: `2px solid ${theme.palette.primary.dark}`,
  },
});

export const editFiltersCheckboxItemSx: SxProps<Theme> = {
  py: 0.5,
};
